import { IndividualConfig, ActiveToast } from 'ngx-toastr';

export abstract class MessageService {
    abstract info(message: string, title?: string, options?: Partial<IndividualConfig>): void;

    abstract success(message: string, title?: string, options?: Partial<IndividualConfig>): void;

    abstract warning(message: string, title?: string, options?: Partial<IndividualConfig>): void;

    abstract error(message: string, title?: string, options?: Partial<IndividualConfig>): void;

    /**
     * Show an info toast and return the ActiveToast reference for click handling
     * Use toast.onTap.subscribe() to handle clicks
     */
    abstract infoClickable(message: string, title?: string, options?: Partial<IndividualConfig>): ActiveToast<unknown>;
}
